import React from 'react';
import { useTranslation } from 'react-i18next';
import EmailLinksTooltip from '../email-links-tooltip';

const EmailLink = ({
    link,
    handleLinkClick,
    handleLinkMouseEnter,
    handleLinkMouseLeave,
    isHoveringOnLink,
}) => {
    const { t } = useTranslation('assessment');

    return (
        <span
            className="link text"
            onClick={() => handleLinkClick(link.clickActionId)}
            onMouseEnter={handleLinkMouseEnter}
            onMouseLeave={handleLinkMouseLeave}
        >
            {t(link.text)}
            <EmailLinksTooltip isVisible={isHoveringOnLink} text={link.href} />
        </span>
    );
};

export default EmailLink;
